function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.513 14.994a1.5 1.5 0 0 1 0-3h12a1.5 1.5 0 0 1 0 3h-12zm0 6a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 0 1 0 3h-6zm19.468 1.727h-3V10.5a1.5 1.5 0 0 0-1.5-1.5H11.5a1.5 1.5 0 0 0-1.5 1.5v23.994a1.5 1.5 0 0 0 1.5 1.5h10.513v3H11.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 11.5 6h17.981a4.5 4.5 0 0 1 4.5 4.5v12.22zm-4.468 16.273a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3c-5.799 0-10.5-4.7-10.5-10.5 0-5.799 4.701-10.5 10.5-10.5 5.8 0 10.5 4.701 10.5 10.5 0 5.8-4.7 10.5-10.5 10.5zm0-9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
});

var Svg005Prepared = function Svg005Prepared(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default Svg005Prepared;


//////////////////
// WEBPACK FOOTER
// ./src/icons/order-status/005-prepared.svg
// module id = 223
// module chunks = 0 1